export enum AccountingPermissions {
  VIEW = 'pitchowner.accounting.view',
  RECEIVE = 'pitchowner.accounting.Receive',
}

export enum FederationsPermissions {
  USERS_VIEW = 'federation.users.view',
  USERS_CREATE = 'federation.users.create',
  USERS_EDIT = 'federation.users.edit',
  TOURNAMENTS_VIEW = 'federation.tournaments.view',
  TOURNAMENTS_VIEW_ORGANIZER = 'federation_organizer.tournaments.view',
  TOURNAMENTS_CREATE = 'federation.tournaments.create',
  TOURNAMENTS_EDIT = 'federation.tournaments.edit',
  ORGANIZERS_VIEW = 'federation.organizers.view',
  ORGANIZERS_CREATE = 'federation.organizers.create',
  ORGANIZERS_EDIT = 'federation.organizers.edit',
  OPERATE_ROLES = 'federation.operate.roles',
  OPERATE_PERMISSIONS = 'federation.operate.permissions',
  REPORTING = 'federation_organizer.reporting',
  TEAMS_OPERATE = 'federation_user.teams.operate',
  TEAMS_VIEW = 'federation_user.teams.view',
}

export enum Admin {
  MARK_AS_PAID = 'admin.user_made_booking.mark_as_paid',
}
